import {
  GET_KIND_FAIL,
  GET_KIND_SUCCESS,
  GET_KINDS_FAIL,
  GET_KINDS_SUCCESS,
  ADD_KIND_SUCCESS,
  ADD_KIND_FAIL,
  UPDATE_KIND_SUCCESS,
  UPDATE_KIND_FAIL,
  DELETE_KIND_SUCCESS,
  DELETE_KIND_FAIL,  
  SET_STATE_KIND
} from "./actionTypes";

const INIT_STATE = {
  kinds: [],
  kind: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const kinds = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_KINDS_SUCCESS:
      return {
        ...state,
        kinds: action.payload.kinds,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_KIND:
      return { ...state, loading: action.payload }

    case GET_KINDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_KIND_SUCCESS:
      return {
        ...state,
        kinds: [...state.kinds, action.payload],
      };

    case ADD_KIND_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_KIND_SUCCESS:
      return {
        ...state,
        kinds: state.kinds.map(kind =>
          kind.id.toString() === action.payload.id.toString()
            ? { ...action.payload, kind }
            : kind
        ),
      };

    case UPDATE_KIND_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_KIND_SUCCESS:
      return {
        ...state,
        kinds: state.kinds.filter(
          kind => kind.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_KIND_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_KIND_SUCCESS:
      return {
        ...state,
        kind: action.payload,
      };

    case GET_KIND_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default kinds;
